import { render, staticRenderFns } from "./FPermitDialog.vue?vue&type=template&id=35f92e50&scoped=true"
import script from "./FPermitDialog.vue?vue&type=script&lang=js"
export * from "./FPermitDialog.vue?vue&type=script&lang=js"
import style0 from "./FPermitDialog.vue?vue&type=style&index=0&id=35f92e50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f92e50",
  null
  
)

export default component.exports